export const monthKeys = [
  'monthName.january',
  'monthName.february',
  'monthName.march',
  'monthName.april',
  'monthName.may',
  'monthName.june',
  'monthName.july',
  'monthName.august',
  'monthName.september',
  'monthName.october',
  'monthName.november',
  'monthName.december',
]

export const monthKeysShort = [
  'monthShortName.january',
  'monthShortName.february',
  'monthShortName.march',
  'monthShortName.april',
  'monthShortName.may',
  'monthShortName.june',
  'monthShortName.july',
  'monthShortName.august',
  'monthShortName.september',
  'monthShortName.october',
  'monthShortName.november',
  'monthShortName.december',
]
export const romanMonthKeys = [
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'XI',
  'XII',
]
